import { useState } from "react";
import ContactClasses from "./Signup.module.css";
import Layout from "Components/Layouts/Common/common";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import CustomButton from "Components/Button";
import { PiEyeClosedBold, PiEyeSlash } from "react-icons/pi";
import { NavLink, useNavigate } from "react-router-dom";
import { Signup } from "Services/Requests";
import ApiService from "Services/config";
import { ProgressBar } from "react-loader-spinner";

type Inputs = {
    name: string;
    email: string;
    confirmemail: string;
    password: string;
    confirmpassword: string;
    phone: string;
    alternate_phone: number;
    source_of_knowing_site: string;
    timezone: string;
    year: number;
    referral_code: any;
};
function Contact() {
    const Navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [confirmPass, setconfirmPass] = useState(false);

    const [Loading, setLoading] = useState(false);
    const [errorMsg, setErrormsg] = useState("");
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<Inputs>();

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        if (data.password != data.confirmpassword) {
            setErrormsg("password and Confirm password must be same");
            return;
        }
        if (data.email != data.confirmemail) {
            setErrormsg("Email and Confirm Email must be same");
            return;
        }
        setLoading(true);
        try {
            const response = await Signup(data);
            setLoading(false);
            if (response?.data?.Status === 1) {
                // setError("");
                ApiService.defaults.headers.common[
                    "Authorization"
                ] = `Bearer ${response?.data?.Token}`;
                localStorage.setItem("Token", response?.data?.Token);
                localStorage.setItem(
                    "UserDetails",
                    JSON.stringify(response?.data?.UserDetails)
                );
                Navigate("/auth/dashboard");
            } else {
                throw new Error(response.data.Message);
            }
        } catch (err: any) {
            setLoading(false);
            setErrormsg(
                err?.response?.data?.error?.name ||
                    err?.response?.data?.Message ||
                    err.message ||
                    "Something went wrong try again later"
            );
        }
    };
    const formatMobile = (value: string) => {
        if (value) {
            const digits = value.replace(/\D/g, "").slice(0, 10); // Get only digits, max 10 digits
            let formatted = "";

            if (digits.length > 0) formatted += digits.slice(0, 3); // First 3 digits
            if (digits.length > 3) formatted += "-" + digits.slice(3, 6); // Next 3 digits
            if (digits.length > 6) formatted += "-" + digits.slice(6, 10); // Last 4 digits

            return formatted;
        }
    };
    return (
        <Layout>
            <div className={ContactClasses["Container"]}>
                <header>
                    <h3>Sign up</h3>
                    <p>Register with Serena Tax in minutes to file returns</p>
                </header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <h3>Sign up</h3>
                    <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">Name</label>
                        <input
                            type="text"
                            className={
                                errors?.name
                                    ? ContactClasses["error-input"]
                                    : ""
                            }
                            placeholder="Type Here"
                            {...register("name", { required: true })}
                        />
                        {errors.name && <p>Name is required</p>}
                    </div>
                    <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">Phone Number</label>
                        <Controller
                            name="phone"
                            control={control}
                            defaultValue=""
                            rules={{
                                pattern: {
                                    value: /^\d{3}-\d{3}-\d{4}$/, // Validate format XXX-XXX-XXXX
                                    message:
                                        "Invalid format. Use XXX-XXX-XXXX for mobile number",
                                },
                            }}
                            render={({
                                field: { onChange, onBlur, value, ref },
                                fieldState: { error },
                            }) => (
                                <>
                                    <input
                                        ref={ref}
                                        value={formatMobile(value)} // Format value for display
                                        style={{
                                            // textIndent: "2.3rem",
                                            width: "100%",
                                        }}
                                        onChange={(e) => {
                                            const rawValue =
                                                e.target.value.replace(
                                                    /\D/g,
                                                    ""
                                                ); // Get raw digits
                                            const formattedValue =
                                                formatMobile(rawValue); // Format for display
                                            onChange(formattedValue); // Update React Hook Form state
                                        }}
                                        onBlur={onBlur}
                                        className={error ? "error-input" : ""}
                                        placeholder="Mobile Number (XXX-XXX-XXXX)"
                                    />
                                    {error && (
                                        <p className="error-message">
                                            {error.message}
                                        </p>
                                    )}
                                </>
                            )}
                        />
                        {errors.phone && <p>Phone number is required</p>}
                    </div>
                    <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">Email</label>
                        <input
                            type="email"
                            className={
                                errors?.email
                                    ? ContactClasses["error-input"]
                                    : ""
                            }
                            placeholder="Enter Email"
                            {...register("email", { required: true })}
                        />
                        {errors.email && <p>Email is required</p>}
                    </div>
                    <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">Confirm Email</label>
                        <input
                            type="email"
                            placeholder="Enter Email"
                            className={
                                errors?.confirmemail
                                    ? ContactClasses["error-input"]
                                    : ""
                            }
                            {...register("confirmemail", {
                                required: "Email Confirmation is required",
                            })}
                        />
                        {errors.confirmemail && (
                            <p>{errors.confirmemail?.message}</p>
                        )}
                    </div>

                    <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">Password</label>

                        <div className={ContactClasses["input-wrapper"]}>
                            <input
                                className={
                                    errors?.password
                                        ? ContactClasses["error-input"]
                                        : ""
                                }
                                {...register("password", {
                                    required: "Password is required",
                                })}
                                type={show ? "text" : "password"}
                                placeholder="Enter Your Password"
                            />
                            {errors.password && (
                                <p>{errors?.password?.message}</p>
                            )}
                            <button
                                type="button"
                                onClick={() => setShow((prev) => !prev)}>
                                {!show ? <PiEyeClosedBold /> : <PiEyeSlash />}
                            </button>
                        </div>
                    </div>
                    <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">Confirm Password</label>
                        <div className={ContactClasses["input-wrapper"]}>
                            <input
                                type={confirmPass ? "text" : "password"}
                                placeholder="Enter Your Password"
                                className={
                                    errors?.confirmpassword
                                        ? ContactClasses["error-input"]
                                        : ""
                                }
                                {...register("confirmpassword", {
                                    required:
                                        "Password confirmation is required",
                                })}
                            />
                            {errors.confirmpassword && (
                                <p>{errors?.confirmpassword?.message}</p>
                            )}
                            <button
                                type="button"
                                onClick={() => setconfirmPass((prev) => !prev)}>
                                {!confirmPass ? (
                                    <PiEyeClosedBold />
                                ) : (
                                    <PiEyeSlash />
                                )}
                            </button>
                        </div>
                    </div>

                    {/*   <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">Year of Tax Filing</label>
                        <select
                            className={
                                errors?.year
                                    ? ContactClasses["error-input"]
                                    : ""
                            }
                            {...register("year", { required: true })}>
                            <option value="">Select</option>
                            <option value="2023">2023</option>
                            <option value="2022">2022</option>
                            <option value="2021">2021</option>
                        </select>
                        {errors.year && <p>Year of Filing is required</p>}
                    </div> */}
                    <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">
                            How do you know about serene Tax Filer ?
                        </label>
                        <select
                            className={
                                errors?.source_of_knowing_site
                                    ? ContactClasses["error-input"]
                                    : ""
                            }
                            {...register("source_of_knowing_site", {
                                required: true,
                            })}>
                            <option value="" disabled>
                                Select
                            </option>
                            <option value="Referral">Referral</option>
                            <option value="Advertisement">Advertisement</option>
                            <option value="Others">Others</option>
                        </select>
                        {errors.source_of_knowing_site && (
                            <p>This is required</p>
                        )}
                    </div>
                    <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">Prefered Time zone</label>
                        <select
                            className={
                                errors?.timezone
                                    ? ContactClasses["error-input"]
                                    : ""
                            }
                            {...register("timezone", { required: true })}>
                            <option value="">Select</option>
                            <option value="CST">
                                Central Standard Time(CST)
                            </option>
                            <option value="EST">
                                Eastern Standard Time(EST)
                            </option>
                            <option value="MST">
                                Mountain Standard Time(MST)
                            </option>
                            <option value="PST">
                                Pacific Standard Time(PST)
                            </option>
                            <option value="IST">
                                Indian Standard Time(IST)
                            </option>
                        </select>
                        {errors.timezone && <p>Timezone is required</p>}
                    </div>
                    <div className={ContactClasses["form-control"]}>
                        <label htmlFor="">Referral Code</label>
                        <input
                            // type="email"
                            placeholder="Enter Referral Code"
                            className={
                                errors?.referral_code
                                    ? ContactClasses["error-input"]
                                    : ""
                            }
                            {...register("referral_code", {
                                required: false,
                            })}
                        />
                    </div>
                    {errorMsg && (
                        <p className={ContactClasses["signup-error"]}>
                            {errorMsg}
                        </p>
                    )}
                    {Loading ? (
                        <div
                            style={{
                                gridColumn: "1/-1",
                                justifySelf: "center",
                            }}>
                            <ProgressBar
                                visible={true}
                                height="80"
                                width="80"
                                barColor="#ccc"
                                borderColor="lightblue"
                                ariaLabel="progress-bar-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                            />
                        </div>
                    ) : (
                        <CustomButton
                            Title="Create Account"
                            type="submit"
                            Theme="Dark"
                        />
                    )}
                    <p>
                        Have an Account?
                        <NavLink to={"/login"}> login</NavLink>
                    </p>
                </form>
            </div>
        </Layout>
    );
}

export default Contact;
